"use client";

import { usePathname } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";

import { useScrollPercentage } from "@/components/scroll-progress-bar";

export default function TrackScrollPercentage() {
  const percent25Reached = useRef(false);
  const percent50Reached = useRef(false);
  const percent75Reached = useRef(false);
  const percent100Reached = useRef(false);
  const scrollPercentage = useScrollPercentage();
  const posthog = usePostHog();
  const pathname = usePathname();

  useEffect(() => {
    if (!posthog) return;
    if (!percent25Reached.current && scrollPercentage >= 25) {
      percent25Reached.current = true;
      posthog.capture("scroll_percentage", { percentage: 25 });
    }
    if (!percent50Reached.current && scrollPercentage >= 50) {
      percent50Reached.current = true;
      posthog.capture("scroll_percentage", { percentage: 50 });
    }
    if (!percent75Reached.current && scrollPercentage >= 75) {
      percent75Reached.current = true;
      posthog.capture("scroll_percentage", { percentage: 75 });
    }
    if (!percent100Reached.current && scrollPercentage === 100) {
      percent100Reached.current = true;
      posthog.capture("scroll_percentage", { percentage: 100 });
    }
  }, [posthog, scrollPercentage]);

  useEffect(() => {
    if (pathname && posthog) {
      // reset on page change
      percent25Reached.current = false;
      percent50Reached.current = false;
      percent75Reached.current = false;
      percent100Reached.current = false;
    }
  }, [pathname, posthog]);

  return null;
}
